import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQS } from "../data/siteData";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-brand-cream"
    >
      <div className="container-app">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <p className="overline mb-4">Common Questions</p>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-brand-forest tracking-tight">
              You probably have questions. We have answers.
            </h2>
            <p className="mt-6 text-base text-brand-muted leading-relaxed">
              Don't see yours below?{" "}
              <a
                href="#lead-form"
                className="text-brand-forest underline underline-offset-4 hover:text-brand-gold-deep"
              >
                Send us a message
              </a>{" "}
              — we respond within one business day.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-brand-line"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="font-heading text-lg md:text-xl font-semibold text-brand-forest hover:text-brand-forest hover:no-underline text-left py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-brand-muted leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
